import React from 'react';
import 'boxicons/css/boxicons.min.css';
import './Section3.scss';
import Dashboard from '../../../../assets/images/HomePageImages/Dashboard.jpg';
import { Link } from 'react-router-dom';
const Section3 = () => {
    return (
        <div className='home-page-section section-3'>
            <div className='home-page-section-content'>
                <div className='image-container'>
                    <img className='dashboard-image' src={Dashboard} alt="" />
                </div>
            </div>
            <div className='home-page-section-content text'>
                <h1>We believe that simply accepting the natural process of aging and responding reactively to related conditions falls short of what patients deserve</h1>
                <p>At Virginia Rehab Physicians, we are committed to supporting the millions of individuals facing functional decline due to aging or complex medical conditions in inpatient rehab facilities, acute care hospitals, and skilled nursing facilities. Through our clinics, we deliver advanced physical medicine and rehabilitation (physiatry) care, ensuring patients and their families receive the highest quality support and treatment wherever it is needed.</p>
                <div className='button-section'>
                    <Link to="/about" className='btn-2'>
                        <i className='bx bx-right-arrow-alt' />
                        Learn More
                    </Link>
                </div>
            </div>
        </div>
    );
};

export default Section3;
